export default "__VITE_ASSET__BxS2aO8s__"